/**
 * utils/status.ts — Helpers de status de ambiente
 * Centralizado de AgentesPage
 */

import { T } from '../styles/tokens';

/**
 * Interface mínima do Environment para typagem
 */
interface Environment {
  status: string;
  online: boolean;
  type?: string;
}

/**
 * Retorna cor do status baseado no estado do ambiente
 */
export function statusColor(env: Environment): string {
  // Estados de criação/provisionamento
  if (
    env.status === 'creating' || 
    env.status === 'provisioning' || 
    env.status === 'configuring_setup' || 
    env.status === 'installing_openclaw'
  ) {
    return T.warning;
  }
  
  // Limite diário atingido
  if (env.status === 'daily_limit_reached') {
    return T.danger;
  }
  
  // Suspenso
  if (env.status === 'suspended') {
    return T.textMuted;
  }
  
  // Online
  if (env.online) {
    return T.success;
  }
  
  // Erro/falha
  if (env.status === 'error' || env.status === 'failed') {
    return T.danger;
  }
  
  // Padrão (offline)
  return T.textSecondary;
}

/**
 * Retorna label do status baseado no estado do ambiente
 */
export function statusLabel(env: Environment): string {
  // Pendências de instalação
  if (env.type === 'pending_installation') {
    return 'Instalando';
  }
  
  if (env.type === 'pending_setup') {
    return 'Aguardando Setup';
  }
  
  // Estados de criação
  const creating = [
    'creating', 
    'provisioning', 
    'configuring_setup', 
    'installing_openclaw', 
    'installing_llm'
  ];
  
  if (creating.includes(env.status)) {
    return 'Criando';
  }
  
  // Online
  if (env.online) {
    return 'Online';
  }
  
  // Erro/falha
  if (env.status === 'error' || env.status === 'failed') {
    return 'Erro';
  }
  
  // Padrão (offline)
  return 'Offline';
}

/**
 * Formata label do plano de forma amigável
 */
export function planLabel(planId?: string, planName?: string): string {
  if (planName) return planName;
  if (!planId) return 'Cloud';
  
  const p = planId.toLowerCase();
  if (p.includes('pro')) return 'Pro';
  if (p.includes('enterprise')) return 'Enterprise';
  if (p.includes('starter')) return 'Starter';
  
  return planId;
}
